import { Field } from 'components/Wizards/Field/Field'
import { PrimaryMarketLocationsProps } from './Types'
import { AddLocationPill } from './AddLocationPill'
import { useState } from 'react'
import { Chip } from 'components/Chip/Chip'
import Styles from './PrimaryMarketLocations.module.scss'

const PrimaryMarketLocations = ({
  locations,
  onUpdate,
  label = 'Primary Market Locations',
  description,
}: PrimaryMarketLocationsProps) => {
  const [adding, setAdding] = useState(false)

  const handleRemove = (location: string) => {
    const newSet = new Set([...locations])
    newSet.delete(location)
    onUpdate(newSet)
  }

  const handleAdd = (location: string) => {
    setAdding(false)
    onUpdate(new Set([...locations, location]))
  }

  return (
    <Field label={label} description={description} headingLevel={3} data-testid="primary-market-locations">
      <div className={Styles.container}>
        {Array.from(locations).map((location) => (
          <Chip
            key={location}
            variant="flat"
            isSelected
            deletable
            selectable={false}
            onPress={() => handleRemove(location)}
          >
            {location}
          </Chip>
        ))}
        <AddLocationPill
          onSelect={handleAdd}
          onActiveChange={(active) => setAdding(active)}
          isActive={adding}
          locations={locations}
        />
      </div>
    </Field>
  )
}

export { PrimaryMarketLocations }
